import { useState, useEffect } from 'react';
import { api } from '../services/api';

interface TarievenHeroData {
  data: {
    id: number;
    attributes: {
      title: string;
      backgroundMedia: {
        data: {
          id: number;
          attributes: {
            url: string;
            alternativeText?: string;
          };
        };
      };
      mediaType: 'image' | 'video';
      videoUrl?: string;
      overlayOpacity: number;
      textColor: 'white' | 'black';
      paddingBottom: number;
      paddingLeft: number;
      paddingRight: number;
    };
  };
}

export const useTarievenHero = () => {
  const [data, setData] = useState<TarievenHeroData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await api.get('/tarieven-hero', {
          params: { populate: 'backgroundImage' }
        } as any);
        
        // Handle Strapi Cloud flattened structure
        const rawData = response.data?.data;
        if (rawData) {
          // Convert flattened structure to expected nested structure
          const convertedData: TarievenHeroData = {
            data: {
              id: rawData.id,
              attributes: {
                title: rawData.title,
                backgroundMedia: rawData.backgroundImage ? {
                  data: {
                    id: rawData.backgroundImage.id,
                    attributes: {
                      url: rawData.backgroundImage.url,
                      alternativeText: rawData.backgroundImage.alternativeText
                    }
                  }
                } : null,
                mediaType: 'image',
                videoUrl: rawData.videoUrl,
                overlayOpacity: rawData.overlayOpacity || 0.3,
                textColor: rawData.textColor || 'white',
                paddingBottom: rawData.paddingBottom || 80,
                paddingLeft: rawData.paddingLeft || 120,
                paddingRight: rawData.paddingRight || 120
              }
            }
          };
          setData(convertedData);
        }
        setError(null);
      } catch (err: any) {
        console.log('Error fetching tarieven hero:', err);
        setError(null); // Don't show error to user, just log it
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
}; 